import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ApisAdminOperatorsCompaniesMutateResponseType } from "~/domains";

type RequestDataType = {
  body: {
    email: string;
    name: string;
    password: string;
    subdomain: string;
  };
};

const request = ({ body }: RequestDataType) => {
  return new ApiClient()
    .post<ApisAdminOperatorsCompaniesMutateResponseType>(
      "/api/admin_operators/companies",
      {
        company: body,
      },
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisAdminOperatorsCompaniesCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<ApisAdminOperatorsCompaniesMutateResponseType> => {
  return useMutation(request, { ...options });
};
